var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"class-builder h-100"},[_c('ed-class-builder',{attrs:{"classId":_vm.classId,"organizationId":_vm.organizationId},on:{"onBack":_vm.returnToAdmin,"onSeePlaceholderSelectedOnCalendar":_vm.goToPlaceholderCalendar}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }